import { render, staticRenderFns } from "./LoginPopup.vue?vue&type=template&id=aa780da8&lang=html&"
import script from "./LoginPopup.vue?vue&type=script&lang=js&"
export * from "./LoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports